export default () => ({
  id: null,
  paymentHash: null,
  status: null,
  chat: {
    isLoading: false,
    isBlocked: false,
    isOpened: false,
    messages: [],
    form: {
      message: ''
    },
  },
  chatErrors: [],
  tourists: [],
  bookings: {},
  bookingsIds: [],
  allBookingsPenalties: [],
  allPenalties: {},
  bookingIsLoading: false,
  isLoading: false,
  isLoadingError: false,
  orderCurrency: 'RUB',
  documents: [],
  documentsFormLoading: {
    isDownloading: false,
    isDownloadingAll: false,
    isSending: false
  },
  documentsForm: {
    bookingId: null,
    email: null
  },
  documentsFormErrors: [],
  country: {
    slug: null,
    mane: null
  },
  price: {
    amount: 0,
    currency: 'RUB',
    debt: 0,
    markup: 0,
    status: null
  },
  feedback: {
    isLoading: false,
    isSended: false,
    showSendingMessage: false,
    showEditMessage: false,
    showForm: true,
    showEditForm: false,
    form: {
      rating: null,
      comment: null,
    }
  },
  include: {
    currencies: [],
    statuses: {},
    documentTypes: {}
  },
  manager: {
    agency: null,
    name: null,
    leader: null,
    phone: null
  },
  dates: {
    create: null,
    start: null,
    payment: null,
    prepayment: null,
    end: null
  }
})